<template>
    <div v-if="hasErrors" class="mb-6 bg-red-50 border border-red-200 rounded-lg p-4">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3 flex-1">
                <h3 class="text-sm font-medium text-red-800">
                    Please correct the following errors:
                </h3>
                <div class="mt-2 text-sm text-red-700">
                    <ul class="list-disc list-inside space-y-1">
                        <li v-for="(error, index) in errorList" :key="index">
                            {{ error }}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="ml-auto pl-3">
                <div class="-mx-1.5 -my-1.5">
                    <button
                        type="button"
                        @click="$emit('dismiss')"
                        class="inline-flex rounded-md bg-red-50 p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 focus:ring-offset-red-50"
                    >
                        <span class="sr-only">Dismiss</span>
                        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ErrorBanner',
    props: {
        errors: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        hasErrors() {
            return this.errorList.length > 0;
        },
        errorList() {
            const errors = [];
            
            // Field mapping for user-friendly labels
            const fieldLabels = {
                'personal.city': 'City',
                'personal.phone_number': 'Phone Number',
                'personal.address': 'Address',
                'personal.state': 'State',
                'personal.zip': 'ZIP Code',
                'personal.ssn': 'SSN',
                'personal.date_of_birth': 'Date of Birth',
                'personal.drivers_license_number': 'Driver\'s License Number',
                'personal.drivers_license_state': 'Driver\'s License State',
                'employment.work_phone': 'Work Phone',
                'employment.employer': 'Employer',
                'banking.routing_number': 'Routing Number',
                'banking.account_number': 'Account Number',
                'banking.official_name': 'Bank Name',
            };
            
            // Collect all errors from all sections
            Object.keys(this.errors).forEach(section => {
                if (section === '_general') {
                    // Handle general errors
                    if (this.errors[section].message) {
                        errors.push(this.errors[section].message);
                    } else if (Array.isArray(this.errors[section])) {
                        errors.push(...this.errors[section]);
                    }
                } else if (this.errors[section] && typeof this.errors[section] === 'object') {
                    // Handle section-specific errors
                    Object.keys(this.errors[section]).forEach(field => {
                        const fieldKey = `${section}.${field}`;
                        const fieldLabel = fieldLabels[fieldKey] || field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                        const errorMessage = this.errors[section][field];
                        
                        if (errorMessage) {
                            errors.push(`${errorMessage}`);
                        }
                    });
                }
            });
            
            return errors;
        }
    }
};
</script>

